















































import Vue from "vue";
import Component from "vue-class-component";
import {Prop, Watch} from "vue-property-decorator";
import type {Document} from "@/api/models/documents/Document";
import {useDocumentsStore} from "@/store/documents";

@Component
export default class DocumentList extends Vue {
  @Prop({type: Number, required: true})
  public readonly deviceId!: number;

  public documents: Document[] = [];
  public isLoading = true;
  public deletingId: number | null = null;

  public async mounted(): Promise<void> {
    await this.loadDocuments();
  }

  @Watch("deviceId")
  public async onDeviceIdChanged(): Promise<void> {
    await this.loadDocuments();
  }

  public async loadDocuments(): Promise<void> {
    this.isLoading = true;
    try {
      const documentsStore = useDocumentsStore();
      this.documents = await documentsStore.getDocumentsByDeviceId(this.deviceId, true);
    } catch (e) {
      console.error("Error loading documents:", e);
      this.documents = [];
    } finally {
      this.isLoading = false;
    }
  }

  public getDownloadUrl(documentId: number): string {
    const documentsStore = useDocumentsStore();
    return documentsStore.getDownloadUrl(documentId);
  }

  public async deleteDocument(documentId: number): Promise<void> {
    if (!confirm("Möchten Sie dieses Dokument wirklich löschen?")) {
      return;
    }

    this.deletingId = documentId;
    try {
      const documentsStore = useDocumentsStore();
      const result = await documentsStore.deleteDocument(documentId, this.deviceId);

      if (result.success) {
        this.documents = this.documents.filter(d => d.id !== documentId);
      } else {
        alert(result.message || "Fehler beim Löschen.");
      }
    } catch (e) {
      console.error("Error deleting document:", e);
      alert("Fehler beim Löschen des Dokuments.");
    } finally {
      this.deletingId = null;
    }
  }

  public getFileIcon(contentType: string): string {
    if (contentType.startsWith("image/")) {
      return "file-image";
    }
    if (contentType === "application/pdf") {
      return "file-pdf";
    }
    if (contentType.includes("word") || contentType.includes("document")) {
      return "file-word";
    }
    return "file";
  }

  public formatFileSize(bytes: number): string {
    if (bytes < 1024) {
      return bytes + " B";
    }
    if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(1) + " KB";
    }
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  }
}
